import { produce } from './produce';
import { removeEdgeById } from './removeEdgeById';

export function removeEdgeFromConnection(connection: any, id: string): any {
  return produce(connection, c => {
    c.edges = removeEdgeById(c.edges, id);
  });
}
